module.exports = __webpack_public_path__ + "img/1.148dfaa4.jpg";